import React, { useState, useEffect } from "react";
import "../Styles/introducation.css";
import { AGENT_LOGIN } from "../utils/store-data-constants";
import { getData } from "../utils/store-data";

const IntroductionVideo = ({
  habitList,
  hobbiesList,
  MainProfile,
  UserData,
  AccesRequestStatus,
}) => {
  const [accessRequested, setAccessRequested] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [isAgentLogin, setIsAgentLogin] = useState(true);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      const data = await getData(AGENT_LOGIN);
      setIsAgentLogin(data);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const profileVideo =
    UserData?.User?.WedLukDocs?.length > 0 &&
    UserData?.User?.WedLukDocs?.[0]?.ProfileVideo;

  return (
    <div className="container-for-intro mx-2">
      {/* Habits */}
      <div className="shadow-for-habits">
        <div className="mb-3">
          <div className="mb-2 title-for-habits">Habits</div>

          <div className="d-flex gap-3 flex-wrap mt-4">
            {habitList
              ?.filter((item) =>
                UserData?.ProfileHabits?.includes(item.HabitId),
              )
              .map((item, idx) => (
                <span
                  key={idx}
                  className="px-3 py-2 d-inline-flex align-items-center habits-style"
                >
                  {item.HabitsName}
                </span>
              ))}
          </div>
        </div>

        {/* Hobbies and Interests */}
        <div className="mb-3 mt-4">
          <div className="mb-2 title-for-habits">Hobbies and Interests</div>

          <div className="d-flex gap-3 flex-wrap mt-4">
            {hobbiesList
              ?.filter((item) =>
                UserData?.ProfileHobbies?.includes(item.HobbiesId),
              )
              .map((item, idx) => (
                <span
                  key={idx}
                  className="px-3 py-2 d-inline-flex align-items-center habits-style"
                >
                  {item.HobbieName}
                </span>
              ))}
          </div>
        </div>
      </div>

      {/* Introduction Video */}
      {profileVideo && (
        <div className="shadow-for-habits mt-3">
          <h5 className="into-title mb-4 mt-4">Introduction video</h5>

          {MainProfile?.ProfileId === UserData?.ProfileId ||
          (MainProfile?.ProfileId !== UserData?.ProfileId &&
            AccesRequestStatus === 2) ||
          UserData?.IsPhotoVisible ? (
            // Video visible
            <video width="90%" height="400px" controls src={profileVideo}>
              Your browser does not support the video tag.
            </video>
          ) : (
            // Video blurred
            <div className="video-blur-container">
              <video
                width="90%"
                height="400px"
                className="blurred-video"
                muted
                src={profileVideo}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IntroductionVideo;
